export const RowContainer = ({ label, children }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <p className="f-18" style={{ marginBottom: 0, width: 180 }}>
      {label}
    </p>
    {children}
  </div>
);
